export const convertToDate = (dateString) => {
    // Remove the " AD" part from the date string
    const cleanedDateString = dateString.replace(" AD", "");
    // Create a new Date object
    const newDate = new Date(cleanedDateString);
    console.log('>>>>>newDate', newDate)
    return newDate
};